import http from "./axios.config"
import { API } from "../constants"

export default class Http {
  static getRoomTypes() {
    return http({
      method: "GET",
      url: `${API}design_templates/design_categories`
    })
      .then((res) => res.data)
  }

  static deleteRoomType(roomTypeId) {
    return http({
      method: "DELETE",
      url: `${API}design_templates/design_categories/${roomTypeId}`
    })
      .then((res) => res.data)
  }

  static getFurnitureCategories() {
    return http({
      method: "GET",
      url: `${API}design_templates/design_categories/design_categories_options`
    })
      .then((res) => res.data)
  }

  static createRoomType(roomData) {
    return http({
      method: "POST",
      url: `${API}design_templates/design_categories`,
      data: roomData
    })
      .then((res) => res.data)
  }

  static getFurnitureCategory(idCategory) {
    return http({
      method: "GET",
      url: `${API}design_templates/design_categories/${idCategory}/edit`
    })
      .then((res) => res.data)
  }

  static updateRoomType(idCategory, roomData) {
    return http({
      method: "PUT",
      url: `${API}design_templates/design_categories/${idCategory}`,
      data: roomData
    })
      .then((res) => res.data)
  }

  static calculateAverageCost(productCategoryId) {
    return http({
      method: "GET",
      url: `${API}design_templates/design_categories/${productCategoryId}/calculate_average_cost`
    })
      .then((res) => res.data)
  }
}
